import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import socket from "../tools/socke";
import DocentesPorMateriaTabla from "./DocentesPorMateriaTabla";

const DocenteBuscadorActivo = ({ devuelvo }) => {
  const [modo, setModo] = useState("docente"); // "docente" o "materia"
  const [visible, setVisible] = useState(false);
  const [docentesFiltrados, setDocentesFiltrados] = useState([]);
  const [filtro, setFiltro] = useState("");
  const [datoPlace, setDatoPlace] = useState("Buscar por apellido o DNI");
  const [materia, setMateria] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, [modo]);

  useEffect(() => {
    socket.on("docenteActualizable", () => {
      if (filtro) {
        obtieneDocente(filtro);
      }
    });
    return () => socket.off("docenteActualizable");
  }, [filtro]);

 
  const obtieneDocente = async (dato) => {
    try {
      if (dato.length > 1) {
        const username = process.env.REACT_APP_KEY;
        const password = process.env.REACT_APP_PASS;
        const token = btoa(`${username}:${password}`);

        const response = await axios.post(
          `https://wwwa.isepsantafe.net.ar/expedientes/docentes/devuelveDocentesActivos/${dato}`,
          { estado: "activo" },
          { headers: { Authorization: `Basic ${token}` } }
        );

        setVisible(true);
        setDocentesFiltrados(response.data.datos || []);
        if ((response.data.datos || []).length === 0) {
          setDatoPlace("No hay docentes con esos datos");
        }
      } else {
        setVisible(false);
        setDocentesFiltrados([]);
      }
    } catch (error) {
      console.error("Error en la petición", error);
    }
  };

  const handleInputChange = (e) => {
    const texto = e.target.value;
    setFiltro(texto);
    obtieneDocente(texto);
  };

  
  const handleDocenteSeleccionado = (docente) => {
    devuelvo(docente);
    setFiltro(`${docente.docenteApellido} ${docente.docenteNombres}`);
    setVisible(false);
    setDocentesFiltrados([]);
  };


const handleMateriaSeleccionada = (docente) => {
  
  setModo("docente");          
//  setFiltro(docente.docenteDni); 
  obtieneDocente(docente.docenteDni); 
};
 
  const ListeaDocentes = ({ items, actualiza }) => (
    <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
      <div style={{ maxWidth: "100%", overflowX: "auto" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "15px",
            backgroundColor: "#fff",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            overflow: "hidden",
          }}
        >
          <tbody>
            {items.map((docente, index) => (
              <tr
                key={index}
                onClick={() => actualiza(docente)}
                style={{ cursor: "pointer", transition: "background 0.2s" }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "#f8f9fa")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "white")
                }
              >
                <td
                  style={{
                    padding: "10px 12px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  title={`${docente.docenteApellido} ${docente.docenteNombres}`}
                >
                  {docente.docenteApellido} {docente.docenteNombres}
                </td>
                <td style={{ padding: "10px", textAlign: "center" }}>
                  {docente.docenteDni}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <div style={{ width: "100%", maxWidth: "500px" }}>
       
        <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginBottom: "10px" }}>
          <button
            className={`btn ${modo === "docente" ? "btn-primary" : "btn-outline-primary"}`}
            onClick={() => setModo("docente")}
          >
            Por Docente
          </button>
          <button
            className={`btn ${modo === "materia" ? "btn-primary" : "btn-outline-primary"}`}
            onClick={() => setModo("materia")}
          >
            Por Materia
          </button>
        </div>

        {modo === "docente" && (
          <>
            <input
              ref={inputRef}
              type="text"
              placeholder={datoPlace}
              value={filtro}
              onChange={handleInputChange}
              style={{
                padding: "10px 15px",
                fontSize: "16px",
                width: "100%",
                boxSizing: "border-box",
                textAlign: "center",
                borderRadius: "8px",
                border: "1px solid #ccc",
                boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                outline: "none",
                transition: "border-color 0.3s ease",
              }}
              onFocus={() => setDatoPlace("Buscar por apellido o DNI")}
            />

            {visible && docentesFiltrados.length > 0 && (
              <div
                style={{
                  maxHeight: "300px",
                  overflowY: "auto",
                  backgroundColor: "white",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  marginTop: "5px",
                  zIndex: 1000,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                }}
              >
                <ListeaDocentes
                  actualiza={handleDocenteSeleccionado}
                  items={docentesFiltrados}
                />
              </div>
            )}
          </>
        )}

        {modo === "materia" && (
          <div style={{ marginTop: "10px" }}>
            <input
              type="text"
              placeholder="Buscar por nombre de materia"
              value={materia}
              onChange={(e) => setMateria(e.target.value)}
              style={{
                padding: "10px 15px",
                fontSize: "16px",
                width: "100%",
                boxSizing: "border-box",
                textAlign: "center",
                borderRadius: "8px",
                border: "1px solid #ccc",
                boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                outline: "none",
                transition: "border-color 0.3s ease",
              }}
            />

            {materia.length >= 4 && (
              <DocentesPorMateriaTabla
                nombreMateria={materia}
                devuelvo={handleMateriaSeleccionada}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default DocenteBuscadorActivo;
